import React from "react"
import { PageDrawerAction } from "src/components/ui/PageDrawerAction"
import { Icons } from "src/components/ui/Icons"
import { useActions, useAppState } from "src/state"
import { ThreadFragment } from "src/state/gql/_types"
import { FormDrawer } from "src/components/forms/FormDrawer"
import { 
    AgencyOperationsAdminThreadCreateFragment, 
    AgencyOperationsAdminThreadCreateSchema
} from "src/components/agency/operations/administrator/threads/AgencyOperationsAdminThreadSchemas"
import { toPgUuidArrayLiteral } from "src/utils/string"

type FormPayloadType = AgencyOperationsAdminThreadCreateFragment

let initialState: FormPayloadType = {
    body: "",
    subject: "",
    recipient_ids: ""
};

export const CreateAgencyOperationsAdminThreadDrawer: React.FC<{onClose():void}> = ({ onClose }) => {

    const { createThreadWithMessage, updateItem, deleteItem } = useActions().threads;
    const { loading, errors } = useAppState().threads;
    
    let currentItemId = null;
    let currentItemData: FormPayloadType | null = null;

    const handleCreate = (payload: FormPayloadType) => {
        const {body, subject } = payload;
        let data = { 
            body,
            subject,
            recipient_ids: toPgUuidArrayLiteral(payload.recipient_ids),
            idempotency_key: crypto.randomUUID(),
            message_type: "text",
            thread_type: "discussion",
            departments: "{}"
        }
        return createThreadWithMessage(data)
    }

    return (
        <>
            <FormDrawer<FormPayloadType, ThreadFragment, string>
                autoOpen={false}
                formSchema={AgencyOperationsAdminThreadCreateSchema}
                createAction={handleCreate}
                updateAction={updateItem}
                deleteAction={deleteItem}
                isLoading={loading}
                errors={errors}
                currentItemId={currentItemId}
                initialData={initialState}
                currentItemData={currentItemData}
                onClose={onClose}
                deleteRedirect={true}
            />

        </>
    )

}

export const CreateAgencyOperationsAdminThreadAction = () => {
    return (
        <PageDrawerAction<ThreadFragment>
            title='Add Thread'
            action={CreateAgencyOperationsAdminThreadDrawer}
            icon={Icons.add}
        />
    )
}